/* eslint-disable react/require-default-props */
/* eslint-disable react/no-danger */
import React from 'react';
import HighlightedText from '../highlighted_text';

interface BiddingItemsProps {
  items: string;
  source: string;
  keywordsList?: Array<string>;
}

const BiddingItems = (props: BiddingItemsProps) => {
  const { items, source, keywordsList = [] } = props;

  const WORDS_THRESHOLD = 3000;
  return (
    <div>
      {items ? (
        <div className="card bg-itens mb-4">
          <div className="card-body">
            <h6 className="bidding-info-title">Itens</h6>
            {(source === 'biddings' || source === 'favorited') && (
              <pre
                className="bidding-info-item-description"
                dangerouslySetInnerHTML={{ __html: items }}
              />
            )}
            {source === 'biddingDetails' && (
              <pre
                className="bidding-info-item-description"
                dangerouslySetInnerHTML={{ __html: items }}
              />
            )}
            {source === 'share' && (
              <pre
                className="bidding-info-item-description"
                dangerouslySetInnerHTML={{ __html: items }}
              />
            )}
            {source === 'bulletin' && keywordsList && items.split(' ').length < WORDS_THRESHOLD && (
              <HighlightedText
                className="col-md-12 p-0 mb-0"
                termsList={keywordsList}
                text={items}
                pre
              />
            )}
            {source === 'bulletin' &&
              keywordsList &&
              items.split(' ').length >= WORDS_THRESHOLD && (
                <pre dangerouslySetInnerHTML={{ __html: items || '-' }} />
              )}
          </div>
        </div>
      ) : (
        <h4 className="text-center text-secondary my-2">Essa licitação não possui itens.</h4>
      )}
    </div>
  );
};

export default BiddingItems;
